export const emphasis = `'TypewriterSerial', source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
monospace`

export const body = `'futura-pt', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`
